import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';

// const useStyles = makeStyles(theme => ({
//     menuColor: {
//         backgroundColor: theme.palette.primary.main,
//         color: '#ffffff',
//     },
//     subColor: {
//         color: '#000000'
//     }
// }));

export default function CustomCardCustomerPolicy({ Icon, title, value }) {
    return (
        <Card sx={{
            minWidth: '100%', backgroundColor: "#E3E3E4",
            "&.MuiCard-root": {
                height: "100%",
                width: "max-content",
                padding: "0 5%"
            }
        }}>
            <CardHeader className='description-large-customer' avatar={<img src={Icon} width={'35px'} />} title={title} subheader={value}
                titleTypographyProps={{ "fontSize": "21px", "fontWeight": "bold", "color": "#696969", "width": "max-content" }}
                subheaderTypographyProps={{ "color": "#c4960c", "fontSize": '30px', "fontWeight": 'bold' }}
                sx={{
                    "&.MuiCardHeader-root": {
                        padding: "2% 0 0 0",
                        margin: "0%"
                    }
                }}
            />
        </Card>
    )
};
